<div class="app-main__inner">

  <!-- ========== LIST VIEW ========== -->
  <div *ngIf="view === 'list'" class="bb-list-view">
    <div class="card bb-fill-card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span class="fw-semibold"><i class="pe-7s-id me-2 text-primary"></i>Users List</span>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-secondary">{{ records.length }} records</span>
          <button type="button" class="btn btn-primary btn-sm" *ngIf="isAdmin" (click)="addNew()">
            <i class="pe-7s-plus me-1"></i> Add New User
          </button>
        </div>
      </div>
      <div class="card-body p-0 bb-fill-body">
        <div class="text-center py-5" *ngIf="isListLoading">
          <div class="spinner-border text-primary"></div>
          <p class="mt-2 text-muted">Loading users...</p>
        </div>
        <vio-table-v2 *ngIf="!isListLoading" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
      </div>
    </div>
  </div>

  <!-- ========== FORM VIEW ========== -->
  <div *ngIf="view === 'form'" class="bb-form-view">
    <div class="bb-form-card">

      <div class="bb-form-header">
        <div class="bb-form-header__title">
          <i class="pe-7s-id"></i>
          {{ isEditMode ? 'Edit User' : 'New User' }}
        </div>
        <button type="button" class="bb-form-header__back" (click)="backToList()">
          <i class="pe-7s-angle-left"></i> Back
        </button>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="bb-form-body">

          <div class="bb-form-section">User Information</div>
          <div class="row g-2">
            <div class="col-md-5">
              <label class="form-label">Full Name <span class="text-danger">*</span></label>
              <input type="text" formControlName="name" class="form-control"
                     [class.is-invalid]="isFieldInvalid('name')" placeholder="Enter full name" />
              <div class="invalid-feedback">
                <span *ngIf="f['name'].errors?.['required']">Name is required.</span>
                <span *ngIf="f['name'].errors?.['minlength']">Must be at least 2 characters.</span>
              </div>
            </div>
            <div class="col-md-4">
              <label class="form-label">Email Address <span class="text-danger">*</span></label>
              <input type="email" formControlName="email" class="form-control"
                     [class.is-invalid]="isFieldInvalid('email')" placeholder="user@example.com"
                     [attr.readonly]="isEditMode ? true : null" />
              <div class="invalid-feedback">
                <span *ngIf="f['email'].errors?.['required']">Email is required.</span>
                <span *ngIf="f['email'].errors?.['email']">Enter a valid email.</span>
              </div>
              <div class="form-text">
                <span *ngIf="!isEditMode"><i class="pe-7s-info me-1"></i>This will be the user's login ID.</span>
                <span *ngIf="isEditMode">Email is the login ID and cannot be changed after creation.</span>
              </div>
            </div>
            <div class="col-md-3">
              <label class="form-label">Role <span class="text-danger">*</span></label>
              <select formControlName="role" class="form-select" [class.is-invalid]="isFieldInvalid('role')">
                <option value="">-- Select Role --</option>
                <option *ngFor="let r of roles" [value]="r">{{ r | titlecase }}</option>
              </select>
              <div class="invalid-feedback">Role is required.</div>
            </div>
          </div>

          <!-- Center Assignment (manager role only) -->
          <ng-container *ngIf="f['role'].value === 'manager'">
            <div class="bb-form-section d-flex align-items-center gap-2">
              <span>Assigned Centers</span>
              <span *ngIf="isCentersLoading" class="spinner-border spinner-border-sm text-primary"></span>
            </div>
            <div class="row g-2" *ngIf="!isCentersLoading">
              <div class="col-12" *ngIf="allCenters.length === 0">
                <p class="text-muted small mb-0">No centers found. Create centers in Center Master first.</p>
              </div>
              <div class="col-md-4" *ngFor="let center of allCenters">
                <div class="form-check um-center-card"
                     [class.um-center-card--selected]="selectedCenterIds.has(center._id)">
                  <input class="form-check-input" type="checkbox"
                         [id]="'center_' + center._id"
                         [checked]="selectedCenterIds.has(center._id)"
                         (change)="toggleCenter(center._id, $event)" />
                  <label class="form-check-label w-100" [for]="'center_' + center._id">
                    <span class="fw-semibold d-block">{{ center.centerName }}</span>
                    <span class="text-muted small">{{ center.area }}</span>
                  </label>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Password section -->
          <div class="bb-form-section d-flex align-items-center justify-content-between">
            <span>{{ isEditMode ? 'Change Password' : 'Set Password' }}</span>
            <button *ngIf="isEditMode" type="button"
                    class="bb-btn-cancel" style="padding: 2px 10px; font-size: 0.72rem;"
                    (click)="toggleChangePassword()">
              {{ changePassword ? 'Cancel' : 'Change Password' }}
            </button>
          </div>

          <div *ngIf="!isEditMode || changePassword" class="row g-2">
            <div class="col-md-5">
              <label class="form-label">Password <span class="text-danger">*</span></label>
              <div class="input-group">
                <input [type]="showPassword ? 'text' : 'password'"
                       formControlName="password" class="form-control"
                       [class.is-invalid]="isFieldInvalid('password')"
                       placeholder="Enter password" />
                <button type="button" class="btn btn-sm btn-outline-secondary"
                        style="border-color:#e2e8f0; height:32px; padding:0 10px;"
                        (click)="showPassword = !showPassword" tabindex="-1">
                  <i [class]="showPassword ? 'pe-7s-close-circle' : 'pe-7s-look'"></i>
                </button>
              </div>
              <div class="invalid-feedback">
                <span *ngIf="f['password'].errors?.['required']">Password is required.</span>
                <span *ngIf="f['password'].errors?.['weakPassword']">Password does not meet all requirements.</span>
              </div>
              <div class="pw-rules mt-2">
                <div class="pw-rule" [class.pw-rule--met]="pwdHas8">Minimum 8 characters</div>
                <div class="pw-rule" [class.pw-rule--met]="pwdHasUpper">At least 1 uppercase letter (A–Z)</div>
                <div class="pw-rule" [class.pw-rule--met]="pwdHasLower">At least 1 lowercase letter (a–z)</div>
                <div class="pw-rule" [class.pw-rule--met]="pwdHasNumber">At least 1 number (0–9)</div>
                <div class="pw-rule" [class.pw-rule--met]="pwdHasSpecial">At least 1 special character (@, $, !, %)</div>
              </div>
            </div>
            <div class="col-md-5">
              <label class="form-label">Confirm Password <span class="text-danger">*</span></label>
              <div class="input-group">
                <input [type]="showConfirm ? 'text' : 'password'"
                       formControlName="confirmPassword" class="form-control"
                       [class.is-invalid]="isFieldInvalid('confirmPassword')"
                       placeholder="Re-enter password" />
                <button type="button" class="btn btn-sm btn-outline-secondary"
                        style="border-color:#e2e8f0; height:32px; padding:0 10px;"
                        (click)="showConfirm = !showConfirm" tabindex="-1">
                  <i [class]="showConfirm ? 'pe-7s-close-circle' : 'pe-7s-look'"></i>
                </button>
              </div>
              <div class="invalid-feedback">
                <span *ngIf="f['confirmPassword'].errors?.['required']">Please confirm your password.</span>
                <span *ngIf="f['confirmPassword'].errors?.['passwordMismatch']">Passwords do not match.</span>
              </div>
            </div>
          </div>

          <div *ngIf="isEditMode && !changePassword" class="form-text mt-1" style="color:#94a3b8;">
            <i class="pe-7s-lock me-1"></i> Password hidden for security. Click "Change Password" above to update.
          </div>

        </div>

        <div class="bb-form-footer">
          <div class="bb-form-footer__msg">
            <span *ngIf="errorMessage" class="text-danger"><i class="pe-7s-close-circle me-1"></i>{{ errorMessage }}</span>
            <span *ngIf="successMessage" class="text-success"><i class="pe-7s-check me-1"></i>{{ successMessage }}</span>
          </div>
          <button type="submit" class="bb-btn-save" [disabled]="isSaving">
            <span *ngIf="!isSaving"><i class="pe-7s-diskette"></i> {{ isEditMode ? 'Update User' : 'Save User' }}</span>
            <span *ngIf="isSaving" class="d-flex align-items-center gap-1"><span class="spinner-border spinner-border-sm"></span> Saving...</span>
          </button>
        </div>
      </form>

    </div>
  </div>

</div>
